import(/* webpackMode: "eager", webpackExports: ["AppInitializer"] */ "/app/apps/store/src/app/AppInitializer.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/store/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthBootProvider"] */ "/app/apps/store/src/app/login/context/AuthBootContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/store/src/app/LoginDocumentShell.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreLoadingCoverGuard"] */ "/app/apps/store/src/app/shop/components/StoreLoadingCoverGuard.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/store/src/app/ShopDocumentShell.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AsyncIconFontLinks"] */ "/app/apps/store/src/components/AsyncIconFontLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AsyncStylesheetLinks"] */ "/app/apps/store/src/components/AsyncStylesheetLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChunkErrorRecovery"] */ "/app/apps/store/src/components/ChunkErrorRecovery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DebugInitializer"] */ "/app/apps/store/src/components/DebugInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DevPanelHost"] */ "/app/apps/store/src/components/DevPanel/DevPanelHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/apps/store/src/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreLoadingCoverAnimation"] */ "/app/apps/store/src/components/StoreLoadingCover/components/StoreLoadingCoverAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreLoadingCoverLabel"] */ "/app/apps/store/src/components/StoreLoadingCover/components/StoreLoadingCoverLabel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DevPanel"] */ "/app/packages/dev-tools/src/panel/DevPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SsrDebugReplay"] */ "/app/packages/dev-tools/src/ssrDebug/SsrDebugReplay.tsx");
